export default __webpack_public_path__ + "img/fjZEONGD.cd706bd6.svg";